import React from "react";
import "./Inclusive_taxes.css";
import Orange_Round_Arrow_Btn from "../../Common-Component/Common_Btn/Orange_Round_Arrow_Btn/Orange_Round_Arrow_Btn";
import UploadFileModal from "../../Common-Component/Common_Modal/UploadFileModal/UploadFileModal";

function Inclusive_taxes({ combination, pincode, product }) {
  const [modalShow, setModalShow] = React.useState(false);
  return (
    <>
      <div className="inclusive-taxes">
        <div className="price-section">
          <h2>
            <span className="price">
              &#8377;{Number(combination?.total).toFixed(2)}
            </span>
            <span className="tax-text"> Inclusive Of All Taxes</span>
          </h2>
          <p>
            For {combination?.Qty?.name} Qty (&#8377;
            {Number(combination?.per_piece).toFixed()} / Piece)
          </p>
        </div>
        {/* <div onClick={() => setModalShow(true)}>
          <Orange_Round_Arrow_Btn btn_name="Continue to Design" />
        </div> */}

        <div
          onClick={() => {
            if (pincode) {
              setModalShow(true);
            }
          }}
          className={!pincode ? "disabled-btn" : ""}
        >
          <Orange_Round_Arrow_Btn btn_name="Continue to Design" />
        </div>

        <p className="note">Note: Fill All The Details To Proceed</p>
      </div>

      <UploadFileModal
      checkOutProcessBaseLink={'/cart-process'}
        product={product}
        combination={combination}
        show={modalShow && !!pincode}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}

export default Inclusive_taxes;
